// Client-side mirror of the server's asset-year selection (RevitYears.PickAssetYear).
//
// The server is the authority — it picks the asset when issuing a download — but the UI needs the
// same answer up front to tell the user, before they click, which version they will get and whether
// their Revit is covered at all. Keeping the rule in one small function here, tested against the
// same cases as the C# side, avoids a round-trip just to render a badge.

/**
 * The asset year a host running `hostYear` would receive: the newest available year at or below it.
 * Null when every available asset is newer than the host — i.e. incompatible.
 *
 * Mirrors Apibim.Contracts.RevitYears.PickAssetYear. A family saved in a newer Revit cannot open in
 * an older one; an older family upgrades automatically, so the newest eligible year is best.
 */
export function pickAssetYear(availableYears: readonly number[], hostYear: number): number | null {
  let best: number | null = null;
  for (const year of availableYears) {
    if (year > hostYear) continue;
    if (best === null || year > best) best = year;
  }
  return best;
}
